import { Box } from '@zillow/constellation';
import Head from 'next/head';
import React, { useEffect } from 'react';

var HubspotEmbed = function HubspotEmbed(_ref) {
  var _ref$region = _ref.region,
    region = _ref$region === void 0 ? 'na1' : _ref$region,
    portalId = _ref.portalId,
    embedId = _ref.embedId,
    elementId = _ref.elementId,
    sfdcCampaignId = _ref.sfdcCampaignId;
  useEffect(function () {
    var createContent = function createContent() {
      if (window.hbspt) {
        window.hbspt.content.create({
          region: region,
          portalId: portalId,
          embedId: embedId,
          elementId: elementId,
          sfdcCampaignId: sfdcCampaignId
        });
      }
    };
    if (window.hbspt) {
      createContent();
    } else {
      var script = document.getElementById('hs-embed');
      if (script) {
        if (script.readyState === 'complete' || script.readyState === 'loaded') {
          createContent();
        } else {
          script.onload = createContent;
        }
      }
    }
  }, [region, portalId, embedId, elementId, sfdcCampaignId]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Head, null, /*#__PURE__*/React.createElement("script", {
    id: "hs-embed",
    src: "https://js.hubspot.com/content-embed/v1.js",
    async: true
  })), /*#__PURE__*/React.createElement(Box, {
    id: elementId,
    sx: {
      minHeight: '400px'
    }
  }));
};
var HubspotEmbed$1 = HubspotEmbed;

export { HubspotEmbed$1 as default };
